module.exports = __webpack_public_path__ + "assets/img/ourfresh.79ae17ed.png";